export enum BillRelationType {
  CREATION = "CREATION",
  COMPONENT = "COMPONENT",
  EXPRESSION = "EXPRESSION",
}
